import { ChangeDetectionStrategy, Component, inject, input, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { ConfirmMenuService } from 'src/app/shared/services/confirm-menu/confirm-menu.service';
import { Participant } from '../chime.service';
import { WaitingRoomListComponent } from '../waiting-room-list/waiting-room-list.component';

@Component({
  selector: 'app-participant-list',
  standalone: true,
  imports: [MatIconModule, MatButtonModule, MatTooltipModule, TranslateModule, WaitingRoomListComponent],
  templateUrl: './participant-list.component.html',
  styleUrls: ['./participant-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ParticipantListComponent {
  // Inputs
  roster = input.required<Participant[]>();
  isHost = input.required<boolean>();
  localUserId = input.required<string>();
  isAudioLocked = input.required<boolean>();
  isCameraLocked = input.required<boolean>();
  isScreenShareLocked = input.required<boolean>();
  isChatLocked = input.required<boolean>();
  activeSpeakerId = input<string | null>(null);
  hostAttendeeIds = input<Set<string>>(new Set());
  waitingParticipants = input<any[]>([]);

  // Outputs
  muteParticipant = output<string>();
  stopVideoParticipant = output<string>();
  kickParticipant = output<string>();
  promoteParticipant = output<string>();
  muteAll = output<void>();
  toggleLockAudio = output<void>();
  toggleLockCamera = output<void>();
  toggleLockScreenShare = output<void>();
  toggleLockChat = output<void>();
  closePanel = output<void>();
  admitParticipant = output<string>();
  rejectParticipant = output<string>();

  private confirmMenuService = inject(ConfirmMenuService);

  onKickClick(event: MouseEvent, attendeeId: string): void {
    event.stopPropagation();
    this.kickParticipant.emit(attendeeId);
  }

  onPromoteClick(event: MouseEvent, attendeeId: string): void {
    event.stopPropagation();
    this.promoteParticipant.emit(attendeeId);
  }
}
